const dropdown_comparison = () => {
    $('.comparison-dropdown').on('change', function() {
        let rowIndex = $(this).val();

        $('.card-container .row').removeClass('active');
        $('.card-container .row[data-row-index="' + rowIndex + '"]').addClass('active');
    });

    $('.comparison-dropdown').select2({
        selectionCssClass: 'custom-comparison-select',
        dropdownCssClass: 'custom-comparison-dropdown',
        minimumResultsForSearch: Infinity
    });
};

export default dropdown_comparison;